<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
        <h5><i class="fa fa-circle" style="color:#800000"></i>&nbsp; My Holidays</h5>
      </div>
<div id="mainContent" class="container">
    <div class="modal-body">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-5 col-form-label">Branch Name</label>
          <div class="col-sm-6">
           <span>{{branchName}}</span>
          </div>
        </div>
      </div>
    </div>
     
    <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-5 col-form-label">Financial Year</label>
            <div class="col-sm-6">
              <select class="form-control form-control-sm mt-1"
                [(ngModel)]="selectYear"
                (change)="getHolidayData()">
                <option value="">Select Year</option>
                <option *ngFor="let yearData of financialYearList" [ngValue]="yearData">
                  {{ yearData.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
  
      <div class="mt-5">
        <div class="row justify-content-center text-center">
          <span class="bg-theme-title"
            >P G BHAGWAT LLP, Chartered Accountants
          </span>
        </div>
        <div class="row justify-content-center text-center ">
          <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
        </div>
     
        <div class="row mt-3">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Holiday Date</th>
                  <th>Holiday Description</th>
                </tr>
              </thead>
              <tbody *ngFor="let data of holidayList">
                <td>{{data.holidayDate | date:'dd/MMMM/yyyy'}}</td>
                <td>{{data.holidayDescription}}</td>
              </tbody>
            </table>
          </div>
      </div>
    </div>
  </div>
  </div>
  